// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 19) return "static/js/28eb74e4d3e8ffaf690a.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"04e78da19afb52eab004","115":"8a7d523be9c8cc5f9a08","116":"01c6bb6bfa287dff6d23"}[chunkId] + ".chunk.js";
};